import { render, staticRenderFns } from "./signup-step-supporter-details.vue?vue&type=template&id=9690e604&scoped=true&"
import script from "./signup-step-supporter-details.vue?vue&type=script&lang=ts&"
export * from "./signup-step-supporter-details.vue?vue&type=script&lang=ts&"
import style0 from "./signup-step-supporter-details.vue?vue&type=style&index=0&id=9690e604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690e604",
  null
  
)

export default component.exports